<template>
  <div class="title-with-link">
    <h2>{{text}}</h2>
    <link-info :nameLink="nameLink" class="u-color--blue" :href="href">{{nameLink}}</link-info>
  </div>
</template>

<script>
  import LinkInfo from "../../../../Core/Link/LinkInfo";
  export default {
    name: "TitleWithLink",
    components: {LinkInfo},
    props: ['text', 'nameLink', 'href'],
    data () {
      return {
        isModalVisible: false,
      };
    },
    methods: {
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      }
    },
  }
</script>

<style lang="scss">
  .title-with-link {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: rem(30px) 0 rem(20px);

    h2 {
      font-size: rem(22px);
      line-height: rem(24px);
      margin: 0 rem(20px) 0 0;
    }
  }
</style>